// «Журналы S3» (SM3–SM7): раздел с вложенными страницами. Пункт меню горит на любой из них — и в боковой панели, и
// в мобильной шторке: условие одно на оба меню, чтобы подсветка не разошлась (04.11 разошёлся сам пункт — его не было
// в шторке).
export const JOURNAL_S3_PATH = '/journal-s3';
export const JOURNAL_S3_SEARCH_PATH = '/journal-s3/search';

export const isJournalS3Path = (pathname = '') => (
  pathname === JOURNAL_S3_PATH || pathname.startsWith(`${JOURNAL_S3_PATH}/`)
);
